import { render } from "./HiPALProTab.vue?vue&type=template&id=5558daf6&ts=true"
import script from "./HiPALProTab.ts?vue&type=script&lang=ts"
export * from "./HiPALProTab.ts?vue&type=script&lang=ts"

import "./HiPALProTab.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__